<template lang="pug">
v-dialog(:value="!!value" @input="close()" max-width="800")
  v-container.pa-0(grid-list-md fluid)
    v-card(v-if="value")
      v-card-title.grey.lighten-4
        span.title Einstellungen
        v-spacer
        v-btn(icon @click="close()"): v-icon close
      v-card-text
        v-layout(wrap v-if="currentUser")
          template(v-for="standort, standortI in standorte")
            template(v-if="standortI === editI")
              v-flex(xs12 md6): v-text-field(label="Standort" v-model="edit.name")
              v-flex(xs12 md3): v-checkbox(label="Standard" v-model="edit.standard" :disabled="edit.standard")
              v-flex(xs12 md3): v-checkbox(label="Ich bin hier" :input-value="edit.id === currentStandort" :disabled="edit.id === currentStandort" @change="updateCurrentStandort(edit.id)")
              v-flex(xs12 md6): v-text-field(label="Bezeugung Name" v-model="edit.bezeugungsSignatur" persistent-hint :hint="`${currentUser.vorname||''} ${currentUser.nachname||''}`")
              v-flex(xs12 md6): v-text-field(label="Bezeugung Ort" v-model="edit.bezeugungsOrt")
              v-flex(xs12 v-if="showToken"): v-text-field(label="Druck Token" v-model="edit.druckToken" type="password")
              template(v-for="druckOptionen in edit.druckOptionen" v-if="editAll || druckOptionen.druckVorlageId === null || druckOptionen.druckVorlageId === value")
                v-flex(xs12 md4): v-select(label="Drucker" v-model="druckOptionen.drucker" :items="druckerOptionenMitStandard(standort, druckOptionen)" item-text="name" item-value="value" persistent-hint :hint="(() => { const vorlage = druckVorlagen.find(d => d.id == druckOptionen.druckVorlageId); return vorlage ? vorlage.name : 'Standard' })()")
                v-flex(xs12 md2): v-text-field(label="Papiereinzug" v-model="druckOptionen.einzug" :disabled="/^__/.test(druckOptionen.drucker)")
                v-flex(xs12 md2): v-select(label="Duplex" v-model="druckOptionen.duplex" :items="duplexOptions" :disabled="/^__/.test(druckOptionen.drucker)")
                v-flex(xs12 md2): v-select(label="Farbe" v-model="druckOptionen.farbe" :items="farbOptions" :disabled="/^__/.test(druckOptionen.drucker)")
                v-flex(xs12 md2): v-select(label="Orientierung" v-model="druckOptionen.orientierung" :items="orientierungOptions" :disabled="/^__/.test(druckOptionen.drucker)")
              v-flex(xs12): v-checkbox(label="Alle Vorlagen" v-model="editAll")
              v-flex(xs12)
                .d-flexx
                  v-btn(@click="save" :loading="loading > 0" color="primary" outline) Speichern
                  v-btn(@click="cancelStandort()" outline) Abbrechen
                  v-spacer
                  v-btn(@click="destroy" :loading="loadingDestroy > 0" outline) Löschen
            template(v-else-if="!edit")
              v-flex(xs12 md6): v-text-field(label="Standort" v-model="standort.name" disabled)
              v-flex(xs12 md3): v-checkbox(label="Standard" :input-value="standort.standard" disabled)
              v-flex(xs12 md3): v-checkbox(label="Ich bin hier" :input-value="standort.id === currentStandort" :disabled="standort.id === currentStandort" @change="updateCurrentStandort(standort.id)")
              v-flex(xs12 md6): v-text-field(label="Bezeugung Name" v-model="standort.bezeugungsSignatur" persistent-hint :hint="`${currentUser.vorname||''} ${currentUser.nachname||''}`" disabled)
              v-flex(xs12 md6): v-text-field(label="Bezeugung Ort" v-model="standort.bezeugungsOrt" disabled)
              template(v-for="druckOptionen in standort.druckOptionen" v-if="druckOptionen.druckVorlageId === null || druckOptionen.druckVorlageId === value")
                v-flex(xs12 md4): v-select(label="Drucker" v-model="druckOptionen.drucker" :items="druckerOptionenMitStandard(standort, druckOptionen)" item-text="name" item-value="value" persistent-hint :hint="(() => { const vorlage = druckVorlagen.find(d => d.id == druckOptionen.druckVorlageId); return vorlage ? vorlage.name : 'Standard' })()" disabled)
                v-flex(xs12 md2): v-text-field(label="Papiereinzug" v-model="druckOptionen.einzug" disabled)
                v-flex(xs12 md2): v-select(label="Duplex" v-model="druckOptionen.duplex" :items="duplexOptions" disabled)
                v-flex(xs12 md2): v-select(label="Farbe" v-model="druckOptionen.farbe" :items="farbOptions" disabled)
                v-flex(xs12 md2): v-select(label="Orientierung" v-model="druckOptionen.orientierung" :items="orientierungOptions" disabled)
              v-flex(xs12): v-btn(@click="editStandort(standort, standortI)" outline :disabled="!!edit") Bearbeiten
              v-flex(xs12): v-divider.mt-3.mb-4
          v-flex(xs12): v-btn(@click="addStandort" outline v-if="!edit") <v-icon>add</v-icon> Standort

</template>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import { uniq } from 'lodash'
import uuidv4 from 'uuid/v4'

const druckerHost = "https://127.0.0.1:9109"

const defaultDruckOptionen = function(druckVorlageId) {
  return {
    id: uuidv4(),
    druckVorlageId: druckVorlageId,
    drucker: druckVorlageId ? '__default' : '__ask',
    einzug: '',
    duplex: null,
    farbe: null,
    orientierung: null,
  }
}

const druckOptionenFor = function(user, druckVorlage, anzahl) {
  let druckOptionen
  let standort
  if (user) {
    const current = localStorage.getItem('druck-vorlage-current-standort')
    standort = user.druckStandorte.find(s => s.id === current) ||
      user.druckStandorte.find(s => s.standard) ||
      user.druckStandorte[0]
  }
  if (standort) {
    const druckVorlageId = druckVorlage && druckVorlage.id || null
    druckOptionen = standort.druckOptionen.find(v => v.druckVorlageId === druckVorlageId)
    if (!druckOptionen || !druckOptionen.drucker || druckOptionen.drucker === "__default") {
      druckOptionen = standort.druckOptionen.find(v => v.druckVorlageId === null) || defaultDruckOptionen()
    }
    const bezeugung = { ort: standort.bezeugungsOrt || '', signatur: standort.bezeugungsSignatur || '' }
    druckOptionen = { ...druckOptionen, token: standort.druckToken, bezeugung }
  } else {
    druckOptionen = defaultDruckOptionen()
  }
  if (druckVorlage) {
    const page = druckVorlage.pages[0] || {}
    druckOptionen.format = page.format || 'A4'
  }
  if (anzahl > 0) {
    druckOptionen.anzahl = anzahl
  } else {
    druckOptionen.anzahl = 1
  }
  return druckOptionen
}

const printPdf = async function(pdf, druckOptionen = defaultDruckOptionen()) {
  const options = {}
  if (druckOptionen.token) {
    options.headers = { Authorization: `Bearer ${druckOptionen.token}` }
  }
  const formData = new FormData()
  formData.append('file', pdf)
  if (druckOptionen.drucker && !/^__/.test(druckOptionen.drucker)) {
    formData.append('printer', druckOptionen.drucker)
    if (druckOptionen.einzug) {
      formData.append('tray', druckOptionen.einzug)
    }
    if (druckOptionen.orientierung) {
      formData.append('orientation', druckOptionen.orientierung)
    }
    if (druckOptionen.duplex) {
      formData.append('duplex', druckOptionen.duplex)
    }
    if (druckOptionen.farbe) {
      formData.append('color', druckOptionen.farbe)
    }
  }
  if (druckOptionen.format) {
    formData.append('format', druckOptionen.format)
  }
  if (druckOptionen.anzahl) {
    formData.append('count', druckOptionen.anzahl)
  }

  const print = await Vue.http.post(`${druckerHost}/print.json`, formData, options)
  return await print.json()
}

const printPdfFor = function(pdf, user, druckVorlage, anzahl) {
  const druckOptionen = druckOptionenFor(user, druckVorlage, anzahl)
  return printPdf(pdf, druckOptionen)
}

export { druckOptionenFor, druckerHost, printPdf, printPdfFor }

export default {
  props: {
    value: String,
  },
  mixins: [GraphqlErrorObject],
  data() {
    return {
      edit: null,
      editI: null,
      editAll: false,
      currentStandort: localStorage.getItem('druck-vorlage-current-standort'),
      druckerVorhanden: [],
      standorte: [],
      druckVorlagen: [],
      loading: 0,
      loadingDestroy: 0,
      duplexOptions: [
        { text: 'Standard', value: null },
        { text: 'Simplex', value: 'simplex' },
        { text: 'Duplex', value: 'duplex' },
        { text: 'Lange Seite', value: 'duplexlong' },
        { text: 'Kurze Seite', value: 'duplexshort' },
      ],
      farbOptions: [
        { text: 'Standard', value: null },
        { text: 'Farbe', value: 'color' },
        { text: 'Monochrom', value: 'monochrom' },
      ],
      orientierungOptions: [
        { text: 'Standard', value: null },
        { text: 'Hochformat', value: 'portrait' },
        { text: 'Querformat', value: 'landscape' },
      ]
    }
  },
  apollo: {
    currentUser: {
      query: gql`query ExtradruckVorlagenSettingsVueCurrentUser {
        currentUser {
          id
          vorname
          nachname
          druckStandorte {
            id
            standard
            name
            bezeugungsSignatur
            bezeugungsOrt
            druckToken
            druckOptionen {
              id
              druckVorlageId
              drucker
              einzug
              duplex
              farbe
              orientierung
            }
          }
        }
      }`
    },
    druckVorlagen: {
      query: gql`query ExtradruckVorlagenSettingsVueDruckvorlagen {
        druckVorlagen {
          id
          name
        }
      }`,
    }
  },
  watch: {
    druckVorlagen(druckVorlagen) {
      this.updateStandorte(this.user, druckVorlagen)
    },
    currentUser: {
      immediate: true,
      handler(user) {
        this.updateStandorte(user, this.druckVorlagen)
      }
    },
    edit: {
      immediate: true,
      handler(value) {
        if (value && !this.druckerVorhanden.length) {
          this.fetchDrucker()
        }
      }
    },
  },
  computed: {
    showToken() {
      return /1|true/.test(this.$route.query.showtoken)
    },
  },
  methods: {
    updateCurrentStandort(id) {
      this.currentStandort = id
      localStorage.setItem('druck-vorlage-current-standort', id)
    },
    updateStandorte(user, druckVorlagen) {
      if (user) {
        const currentStandort = this.currentStandort
        let currentExists = false
        let standardId = null
        this.standorte = user.druckStandorte.map(standort => {
          const druckOptionen = standort.druckOptionen.map(o => ({ ...o, __typename: undefined }))
          druckVorlagen.forEach(vorlage => {
            if (!druckOptionen.some(o => o.druckVorlageId === vorlage.id)) {
              druckOptionen.push(this.defaultDruckOptionen(vorlage.id))
            }
          })
          if (standort.standard) {
            standardId = standort.id
          }
          if (currentStandort === standort.id) {
            currentExists = true
          }

          return { ...standort, druckOptionen }
        })

        if (druckVorlagen.length && !currentExists && standardId) {
          this.updateCurrentStandort(standardId)
        }
      }
    },
    druckerOptionenMitStandard(standort, druckOptionen) {
      const drucker = standort.druckOptionen.find(d => d.id === druckOptionen.id).drucker
      const druckerVorhanden = [].concat(this.druckerVorhanden)
      if (drucker && !/^__/.test(drucker) && !druckerVorhanden.some(dv => dv.value === drucker)) {
        druckerVorhanden.unshift({ name: drucker, value: drucker })
      }
      druckerVorhanden.unshift({ name: 'Nachfragen', value: '__ask' })
      if (druckOptionen.druckVorlageId) {
        druckerVorhanden.unshift({ name: 'Standard', value: '__default' })
      }
      return druckerVorhanden
    },
    addStandort() {
      this.standorte.push({
        id: uuidv4(),
        name: '',
        standard: this.standorte.length === 0,
        bezeugungsSignatur: '',
        bezeugungsOrt: '',
        druckToken: '1',
        druckOptionen: [this.defaultDruckOptionen(null), ...this.druckVorlagen.map(v => this.defaultDruckOptionen(v.id))]
      })
      this.editStandort(this.standorte[this.standorte.length - 1], this.standorte.length - 1)
    },
    defaultDruckOptionen: defaultDruckOptionen,
    editStandort(standort, standortI) {
      this.editI = standortI
      this.edit = { ...standort, druckOptionen: standort.druckOptionen.map(o => ({ ...o })) }
    },
    cancelStandort() {
      this.editI = null
      this.edit = null
      this.editAll = false
    },
    close() {
      this.cancelStandort()
      this.gqlClearAllErrors()
      this.$emit('reload')
      this.$emit('input', null)
    },
    save() {
      this.loading++
      this.gqlClearAllErrors()
      this.$apollo.mutate({
        mutation: gql`mutation ExtraDruckVorlagenEditVueCreate(
          $id: ID!,
          $standard: Boolean,
          $name: String,
          $bezeugungsSignatur: String,
          $bezeugungsOrt: String,
          $druckToken: String,
          $druckOptionen: [DruckOptionenInput]
        ) {
          druckVorlageSettingsUpdate(
            id: $id,
            standard: $standard,
            name: $name,
            bezeugungsSignatur: $bezeugungsSignatur,
            bezeugungsOrt: $bezeugungsOrt,
            druckToken: $druckToken,
            druckOptionen: $druckOptionen,
          ) {
            id
            druckStandorte {
              id
              standard
              name
              bezeugungsSignatur
              bezeugungsOrt
              druckToken
              druckOptionen {
                id
                druckVorlageId
                drucker
                einzug
                duplex
                farbe
                orientierung
              }
            }
          }
        }`,
        variables: this.edit,
      }).then((data) => {
        this.loading--
        this.close()
      }, (error) => {
        this.gqlAddErrors(error)
        this.loading--
      })
    },
    destroy() {
      this.loadingDestroy++
      this.gqlClearAllErrors()
      this.$apollo.mutate({
        mutation: gql`mutation ExtraDruckVorlagenEditVueDestroy(
          $id: ID!,
        ) {
          druckVorlageSettingsDestroy(
            id: $id,
          ) {
            success
            user {
              id
              druckStandorte {
                id
                standard
                name
                bezeugungsSignatur
                bezeugungsOrt
                druckToken
                druckOptionen {
                  id
                  druckVorlageId
                  drucker
                  einzug
                  duplex
                  farbe
                  orientierung
                }
              }
            }
          }
        }`,
        variables: {
          id: this.edit.id
        },
      }).then((data) => {
        this.loadingDestroy--
        this.close()
      }, (error) => {
        this.gqlAddErrors(error)
        this.loadingDestroy--
      })
    },
    async fetchDrucker() {
      try {
        const options = {}
        const token = this.edit.druckToken
        if (token) {
          options.headers = { Authorization: `Bearer ${token}` }
        }
        let druckerVorhanden = await this.$http.get(`${druckerHost}/printers`, options)
        this.druckerVorhanden = (await druckerVorhanden.json()).map(d => ({ name: d.name, value: d.name }))
      } catch (error) {
      }
    }
  },
}
</script>
